import { render } from "./Widget11.vue?vue&type=template&id=daac67c8&scoped=true"
import script from "./Widget11.vue?vue&type=script&lang=js"
export * from "./Widget11.vue?vue&type=script&lang=js"

import "./Widget11.vue?vue&type=style&index=0&id=daac67c8&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daac67c8"]])

export default __exports__